module.exports = __webpack_public_path__ + "img/no-emp-activity-hours.da40fa79.png";